<script lang="ts">
export let item: any;
</script>

<pre>{JSON.stringify(item, null, 2)}</pre>
